export default __webpack_public_path__ + "static/media/loading-indicator-inverted.bb949b43.gif";